import { Routes } from '@angular/router';
import { RogueAccessPointsComponent } from '@app/features/mists/modules/rogue-ap-audit/rogue-ap-audit.component';
import { Authority } from '@app/shared/utils/enums';

export const rogueAcessPointRoutes: Routes = [
    {
        path: 'mist-rogue-ap-audit',
        children: [
            {
                path: '',
                component: RogueAccessPointsComponent,
                data: {
                    authorities: [Authority.ADMIN]
                }
            }
        ]
    }
]